import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-new-method": "",
  class: "flex flex-col gap-4 rounded-[10px] border border-gray-200 bg-white px-[22px] py-5"
}
const _hoisted_2 = { class: "grid gap-4 sm:grid-cols-3" }
const _hoisted_3 = {
  key: 2,
  "data-area-map": ""
}
const _hoisted_4 = { class: "mb-2 text-sm font-medium text-gray-700" }
const _hoisted_5 = { class: "mb-2 text-sm font-medium text-gray-700" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 flex flex-wrap items-center gap-2 text-sm text-gray-700"
}

import { computed } from 'vue'
import { useStore } from 'vuex'

import GoogleMapComponent from '@/components/GoogleMapComponent.vue'
import InputField from '@/components/neue/InputField.vue'
import MultiSelectInput from '@/components/neue/MultiSelectInput.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import ZipCodeList from '@/components/neue/wizard/ZipCodeList.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { HOURS, newMethodDraft, sectionCopy, WINDOW_PRESETS, ZONE_KINDS } from '@/config/dropWizardSteps'
import { formatClock } from '@/helpers/dropWizardDates'
import australiaStates from '@/models/australiaStates'
import canadianStates from '@/models/canadianStates'
import unitedKingdomStates from '@/models/unitedKingdomStates'
import usaStates from '@/models/usaStates'


export default {
  __name: 'StepGet',
  props: { methods: { type: Array, default: () => [] } },
  setup(__props) {

const props = __props
const wizard = injectWizard()
const fulfillment = computed(() => wizard.data.fulfillment)

const STATES_BY_COUNTRY = { USA: usaStates, CAN: canadianStates, AUS: australiaStates, GBR: unitedKingdomStates }
const STATE_LABELS = { USA: 'states', AUS: 'states', CAN: 'provinces', GBR: 'counties' }
const store = useStore()
const country = computed(() => store.getters.country)
const stateOptions = computed(() =>
  (STATES_BY_COUNTRY[country.value] ?? usaStates).map(s => ({ name: s.label, value: s.value }))
)
const stateLabel = computed(() => STATE_LABELS[country.value] ?? 'states')

const chosen = computed(() => props.methods.find(method => method.id === fulfillment.value.methodId))
const pickup = computed(
  () => (fulfillment.value.newMethod ? fulfillment.value.newMethod.type : chosen.value?.type ?? 'pickup') === 'pickup'
)

const chooseExisting = id => {
  fulfillment.value.newMethod = null
  fulfillment.value.methodId = id
}

const startNew = () => {
  fulfillment.value.methodId = null
  fulfillment.value.newMethod = fulfillment.value.newMethod ?? newMethodDraft()
}

const windowOptions = WINDOW_PRESETS.map(preset => ({
  value: preset.value,
  name: preset.start ? `${preset.name} · ${formatClock(preset.start)} to ${formatClock(preset.end)}` : 'Custom'
}))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('method', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "Fulfillment method" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.methods, (method) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: method.id,
                name: groupName,
                icon: method.type === 'pickup' ? 'store' : 'repeat',
                title: method.name,
                subtitle: method.detail,
                selected: !fulfillment.value.newMethod && fulfillment.value.methodId === method.id,
                onSelect: $event => (chooseExisting(method.id))
              }, null, 8, ["name", "icon", "title", "subtitle", "selected", "onSelect"]))
            }), 128)),
            _createVNode(SelectionCard, {
              name: groupName,
              icon: "invite",
              title: "Set up a new way",
              subtitle: "Pickup at an address, or delivery to zip codes, states or a drawn area.",
              selected: Boolean(fulfillment.value.newMethod),
              onSelect: startNew
            }, null, 8, ["name", "selected"])
          ]),
          _: 1
        }),
        (fulfillment.value.newMethod)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(PillRadioGroup, {
                modelValue: fulfillment.value.newMethod.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((fulfillment.value.newMethod.type) = $event)),
                label: "Pickup or delivery",
                options: [
          { value: 'pickup', name: 'Pickup' },
          { value: 'delivery', name: 'Delivery' }
        ]
              }, null, 8, ["modelValue"]),
              _createVNode(InputField, {
                modelValue: fulfillment.value.newMethod.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((fulfillment.value.newMethod.name) = $event)),
                name: "Name",
                placeholder: "e.g. Pickup at the gym"
              }, null, 8, ["modelValue"]),
              (fulfillment.value.newMethod.type === 'pickup')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(InputField, {
                      modelValue: fulfillment.value.newMethod.address.address1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((fulfillment.value.newMethod.address.address1) = $event)),
                      name: "Street address"
                    }, null, 8, ["modelValue"]),
                    _createVNode(InputField, {
                      modelValue: fulfillment.value.newMethod.address.address2,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((fulfillment.value.newMethod.address.address2) = $event)),
                      name: "Apartment, suite (optional)"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(InputField, {
                        modelValue: fulfillment.value.newMethod.address.city,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((fulfillment.value.newMethod.address.city) = $event)),
                        name: "City"
                      }, null, 8, ["modelValue"]),
                      _createVNode(InputField, {
                        modelValue: fulfillment.value.newMethod.address.state,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((fulfillment.value.newMethod.address.state) = $event)),
                        name: "State"
                      }, null, 8, ["modelValue"]),
                      _createVNode(InputField, {
                        modelValue: fulfillment.value.newMethod.address.zip,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((fulfillment.value.newMethod.address.zip) = $event)),
                        name: "Zip"
                      }, null, 8, ["modelValue"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "m-0 text-sm font-medium text-gray-700" }, "Where do you deliver?", -1)),
                    _createVNode(PillRadioGroup, {
                      modelValue: fulfillment.value.newMethod.zone.kind,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((fulfillment.value.newMethod.zone.kind) = $event)),
                      label: "Delivery area",
                      options: _unref(ZONE_KINDS)
                    }, null, 8, ["modelValue", "options"]),
                    (fulfillment.value.newMethod.zone.kind === 'zips')
                      ? (_openBlock(), _createBlock(ZipCodeList, {
                          key: 0,
                          modelValue: fulfillment.value.newMethod.zone.zipCodes,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((fulfillment.value.newMethod.zone.zipCodes) = $event))
                        }, null, 8, ["modelValue"]))
                      : (fulfillment.value.newMethod.zone.kind === 'states')
                        ? (_openBlock(), _createBlock(MultiSelectInput, {
                            key: 1,
                            modelValue: fulfillment.value.newMethod.zone.states,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((fulfillment.value.newMethod.zone.states) = $event)),
                            options: stateOptions.value,
                            placeholder: `Pick ${stateLabel.value}`
                          }, null, 8, ["modelValue", "options", "placeholder"]))
                        : (fulfillment.value.newMethod.zone.kind === 'map')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "m-0 mb-2 text-sm text-gray-600" }, " Click the map to draw the area you deliver to. At least three points. ", -1)),
                              _createVNode(GoogleMapComponent, {
                                modelValue: fulfillment.value.newMethod.zone.waypoints,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((fulfillment.value.newMethod.zone.waypoints) = $event)),
                                mode: "region"
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('arrival', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(pickup.value ? 'When can they pick it up?' : 'When does it arrive?'), 1),
          _createVNode(PillRadioGroup, {
            modelValue: _unref(wizard).data.arrival.offsetDays,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_unref(wizard).data.arrival.offsetDays) = $event)),
            label: "Arrival day",
            options: [
          { value: 0, name: 'Same day I make it' },
          { value: 1, name: 'The next day' }
        ]
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(pickup.value ? 'Between what times?' : 'Delivery window'), 1),
          _createVNode(PillRadioGroup, {
            modelValue: _unref(wizard).data.arrival.window,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_unref(wizard).data.arrival.window) = $event)),
            label: "Arrival window",
            options: _unref(windowOptions)
          }, null, 8, ["modelValue", "options"]),
          (_unref(wizard).data.arrival.window === 'custom')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "From", -1)),
                _createVNode(SelectInput, {
                  modelValue: _unref(wizard).data.arrival.start,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_unref(wizard).data.arrival.start) = $event)),
                  name: "From",
                  options: _unref(HOURS)
                }, null, 8, ["modelValue", "options"]),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "to", -1)),
                _createVNode(SelectInput, {
                  modelValue: _unref(wizard).data.arrival.end,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_unref(wizard).data.arrival.end) = $event)),
                  name: "To",
                  options: _unref(HOURS)
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}